export default __webpack_public_path__ + "media/images/workers-649c49460bb87bc3e78a60a1e76f7f04.jpg";